import { Component } from '@angular/core';
import { AuthService } from '../../services/auth-service.service';
import { RouteDataService } from '../../services/routedata.services';
import { ActivatedRoute } from '@angular/router';
import { S1DataService } from '../../services/s1data.service';
import { environment } from '../../../environments/environment';
import { FezaDataService } from '../../services/fezadata.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
  isExpanded = true;
  restrictedMode: boolean = false;
  healthPath: string = environment.genPopUrl + '/healthui';

  constructor(public auth: AuthService,
    private routedataservice: RouteDataService,
    private s1DataServce: S1DataService,
    private fezaDataService: FezaDataService) {

    this.fezaDataService.GetS1RestrictedModeEnabled().subscribe(enabled => {
      if (enabled) {
        this.s1DataServce.getFezaUserInfo().subscribe(ui => this.restrictedMode = ui.groups.indexOf(environment.s1FizzyAdminGroup) == -1);
      }
    });
  }

  collapse() {
    this.isExpanded = false;
  }

  onNewBid() {
    this.routedataservice.clear(); 
    this.collapse();
  }

  onLogout() {
    this.auth.logout();
    this.collapse();
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/nav-menu/nav-menu.component.ts